import React from 'react'
import { styled } from 'linaria/react'

const StyledToggle = styled.div`
   padding-bottom: 0.5rem;
   // Override boostrap class "form-check-input"
   .form-check-input {
      cursor: pointer;
      border-color: #707070;
      margin-right: 0.5rem;
      box-shadow: none;
   }
   .form-check-input:hover {
      background-color: #dcdcdc;
   }
   .form-check-input:checked {
      background-color: var(--color-vb-blue);
      border-color: var(--color-vb-blue-darker);
      &:hover {
         opacity: 0.8;
      }
   }

   .label {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;
      font-weight: 600;
   }
`

export const ToggleFilter = ({
   filters = [],
   facetCount,
   fieldName,
   label,
   onToggleChange,
   isChecked,
}) => {

   return (
      <StyledToggle>
         <input
            type="checkbox"
            className="form-check-input"
            checked={isChecked?.({ fieldName, filters })}
            onChange={() => {
               onToggleChange?.({ fieldName, value: !isChecked?.({ fieldName, filters }) })
            }}
            id={`toggle-${fieldName}`}
            name={fieldName}
            aria-checked={isChecked?.({ fieldName, filters }) ?? false}
         />
         <label className="label" htmlFor={`toggle-${fieldName}`}>
            {label} {facetCount !== undefined ? `(${facetCount})` : ''}
         </label>
      </StyledToggle>
   )
}
